import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Currency } from '@hdms/shared/common-types';
import { WindowRefService } from '@hdms/shared/util-core';

import { HeaderConfigService, MenuStateService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-select-currency',
  templateUrl: './select-currency.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectCurrencyComponent {
  @Input() inContentBox: boolean;

  readonly currencyConfig$ = this.configService.currencyConfig$;

  constructor(
    private readonly menuState: MenuStateService,
    private readonly configService: HeaderConfigService,
    private readonly winRef: WindowRefService
  ) {}

  onCurrencyChange([currency]: Currency[]): void {
    this.configService.switchCurrency(currency.code);
    this.menuState.closeAll();
    this.winRef.nativeWindow.location.reload();
  }
}
